export default async function getVideoFromBrightcove(
  videoId,
  accountId,
  adConfigId,
  policyKey,
  configId
) {
  const url = [
    `https://edge.api.brightcove.com/playback/v1/accounts/${accountId}/videos/${videoId}`,
    `?ad_config_id=${adConfigId}`,
    `&config_id=${configId}`,
  ].join('')

  try {
    const response = await fetch(url, {
      headers: {
        Accept: `application/json;pk=${policyKey}`,
      },
    })
    const json = await response.json()
    return json
  } catch (error) {
    return error
  }
}
